

(function() {
  // Add custom code below this line
  function playPauseVideo() {
    let videos = document.querySelectorAll("video");
    videos.forEach((video) => {
      // We can only control playback without insteraction if video is mute
      video.muted = true;
      // Play is a promise so we need to check we have it
      let playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.then((_) => {
          let observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (
                  entry.intersectionRatio !== 1 &&
                  !video.paused
                ) {
                  video.pause();
                } else if (video.paused) {
                  video.play();
                }
              });
            },
            { threshold: 0.2 }
          );
          observer.observe(video);
        });
      }
    });
  }

  async function executePlay() {
    while (true)
    {
      playPauseVideo();
      await new Promise(r => setTimeout(r, 200));
    }
  }

  executePlay();
  
    // ^^ Keep your scripts inside this IIFE function call to 
    // avoid leaking your variables into the global scope.
})();

(function() {
  const swatches = document.querySelectorAll(".swatch__button");
  
  for (var i = 0; i < swatches.length; i++) {
    const target = swatches[i];
    target.addEventListener('mouseenter', () => {
      const colorTitle = document.querySelector(".product_option_title");
      const colorName = target.getAttribute("data-tooltip");
      let isSelected = false;

      for (const child of target.children) {
        if (child.hasAttribute("current-color")) {
          isSelected = true;
        }
      }

      if (isSelected) {
        colorTitle.style.color = "#212121";
      }
      else {
        colorTitle.style.color = "#b0b0b0";
      }

      colorTitle.textContent = colorName;
    });
  }
})();

